<template>
	<div class="">
		<Header></Header>
		<div class="ZhaokaoMore">
			<div class="serchbtn">
			     <p></p>
                 <p @click="openprop">筛选</p>
			</div>
			
			 	<div class="tabs">
                 	<van-tabs v-model="active1" title-inactive-color='#666' title-active-color='#007CCF' background="#fafafa" @click="onClicktab"
				@change='onClicktab'    swipeable animated  :ellipsis=false><!--swipeable允许滑动-->

					<van-tab v-for="(item,index) in typeData" :key="index" :title="item.name" :name='index'>
						<div class="listSwiper">

							
							<div>
                                <ul>
									<li  v-for="(item,index) in listData" :key="index" @click="opendetail(item.id)">
										<div class="listL">
											<div v-if='item.synCalendar==0'>
                                               		<div class="icontype3">
										              <p>查看详情</p>
									               </div>
											</div>
										   <div v-else>
												<div class="icontype1" v-if='nowData < item.signUpTimeStart'>
													<p>即将报名</p>
												</div>
                                                 <div class="icontype1" v-if='nowData > item.signUpTimeStart'>
													<p>报名截止</p>
												</div>

											</div>
										</div>
										<div class="listR">
											<p>
												<span>【{{strtype}}】</span><span>{{item.title}}</span>
											</p>
											<p>{{item.contentPart.substring(0,30)}}...</p> 
											<p>
												<span>{{item.siteName}}</span> <span>{{item.ctime | dateFormat}}</span>
											</p>
										</div>
									</li>
								
								</ul>
							</div>				
						</div>
					</van-tab>                
				</van-tabs>
			</div>
			
		
		</div>
		<div>
		
		</div>
         <!--更多-->
		 							
         <!--更多-->
		 <div v-if='listlen !=0'>
              <van-pagination 
			v-model="currentPage" 
			:page-count="totals"
			mode="simple" 
			@change='changepahe'
			/>
		 </div>
		
		 <!---->
		 <div v-show="notshow">
		    <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }">
			  暂无相关文章
	    	</van-divider>
		 </div>
		 <!---->
		<Fotter></Fotter>
		<div class="addreschose" v-if="show">
				<div class="addbox">
				<div class="addresS">
					 <p>信息属性</p>
					 <ul>
						<li  v-for="(item,index) in treeinfo" :key="index"  v-bind:class="{ blue:index==current1}"  @click="choseinfo(item.id,item.code,index)">{{item.name}}</li>
					 </ul>
				 </div>
				 <div class="addresS">
					 <p>省份</p>
					 <ul>
						<li v-for="(item,index) in treeList" :key="item.id" v-bind:class="{ blue1:index==current2}"   @click="clickItem(item.children,item.id,item.code,index)">
							{{item.name}}
					   	</li>
					 </ul>
				 </div>
				  <div class="addresS">
					 <p>地区</p>
					 <ul>
					<li v-for="(item,index) in twoData" :key="item.id" v-bind:class="{ blue2:index==current3}"  @click="clickItem1(item.id,item.code,index)">
						{{item.name}} 	</li>
					 </ul>
				  </div>
			
				 <div class="dbbtn">
					  <p @click="hideaddreschose">取消</p>
					  <p  @click="hideaddreschose">确定</p>
				 </div>
			</div>
		</div>	
	</div>
</template>

<script>
	import Header from "./Header.vue";
	import Fotter from "./Fotter.vue";
	import __Config from '../api/config';
	export default {
		name: 'ZhaokaoMore',
		components: {
			Header,
			Fotter
		},
		data() {
			return {
				ellipsis: false,
				indicators: false,
			
                active1:0,
				current1:-1, //筛选信息class 的index 
				current2:-1, //省 的index 
				current3:-1,
				show:false,
				nowData: (new Date()).getTime(),
				siteId: this.$store.state.treeData.id, //站点ID
				siteCode:this.$store.state.treeData.code, //站点code
				moduleId:null,  //模块id 
				moduleCode:null,  //模块code



				typeData:[],//考试类型
				listData:[],//数据列表
				 listlen:null,
				strtype:"",//截取的类型 只要最后一页/后面的内容
				treeinfo:[],//模块下的信息
				treeList:[],//省
				twoData:[],//地区

                notshow:false,//当没有数据的时候显示
                currentPage:1, //当前页
                totals:null//总页数
			}

		},
		methods: {
		    //点击tab切换 方法很原始 有待优化
			onClicktab(event) {
				var ids =    this.typeData.map(function(item){return  item.id; })
				var codes =    this.typeData.map(function(item){return  item.code})
				if(event==0){
					this.moduleId = ids[0];
					this.moduleCode = codes[0]
					  this.currentPage=1;
				}else if(event==1){
					this.moduleId = ids[1];
					this.moduleCode = codes[1];
					  this.currentPage=1;
				}if(event==2){
					this.moduleId = ids[2];
					this.moduleCode = codes[2]
					  this.currentPage=1;
				}if(event==3){
					this.moduleId = ids[3];
					this.moduleCode = codes[3];
					  this.currentPage=1;
				}if(event==4){
					this.moduleId = ids[4];
					this.moduleCode = codes[4];
					  this.currentPage=1;
				}if(event==5){
					this.moduleId = ids[5];
					this.moduleCode = codes[5]
					  this.currentPage=1;
				}
			 this.moreList();	//获取对应的数据
			 this.getmoduletrees();//获取对应的信息属性
			},
		    //打开筛选
			openprop(){
				this.show=true;
			},
			hideaddreschose(){
				this.show=false;
			},
			moreList(){ //getarticlePage
			  this.$toast.loading({
					duration: 0,  
					mask: true,
					message: '加载中...'
				});
                 var that = this;
			      this.$axios.get(__Config.api.getarticlePage,{
					params: {
						pageNo:this.currentPage,
						pageSize:5,
						siteId:this.siteId,
						siteCode:this.siteCode,
						moduleId:this.moduleId,
						moduleCode:this.moduleCode,
					}
				})
				.then(function (res) {
						 that.$toast.clear();	 
					that.listData = res.data.data;
						that.listlen = res.data.data.length;

				
					for(var i=0;i<res.data.data.length;i++){
						 var str =  res.data.data[i].moduleName;
						 var index = str .lastIndexOf("\/");  
					  	 that.strtype  = str.substring(index + 1, str.length);
					
					}
			    if(res.data.data.length==0){
						that.notshow =true;
					}else{
						 	that.notshow =false;
					}
			        that.totals=   res.data.page.countPage; //总页数
					
				})
				.catch(function (err) {
						 that.$toast.clear();	 
					console.log(err);
				});
			},
            changepahe(e){
				this.currentPage= e;
				this.moreList();
              
			},
			//考试类型
			getType(){//getexamType
				  var that = this;
			      this.$axios.get(__Config.api.getexamType,{
				
				})
				.then(function (res) {
					that.typeData = res.data.data;
					that.moduleCode = res.data.data[0].code; //默认显示特岗的模块擦code
                    that.moduleId = res.data.data[0].id; //默认显示特岗的模块id
					//请求成功在获取数据
					 that.moreList();
					//去获取模块树结构
					 that.getmoduletrees();
				})
				.catch(function (err) {
					console.log(err);
				});
			},

			//获取模块树结构
			getmoduletrees(){ //getmoduletree
                  var that = this;
			      this.$axios.get(__Config.api.getmoduletree,{
				  params: {
					    moduleId:this.moduleId
					}
				})
				.then(function (res) {
				  that.treeinfo = res.data.data[0].children;
				 // console.log( res.data.data[0].children);
				})
				.catch(function (err) {
					console.log(err);
				});
			},
			//点击信息筛选
			choseinfo(id,code,index){
				this.current1 = index; //选中当前
				//改变模块的 id code
				this.moduleId = id;
				this.moduleCode =code;
				//再次拉去数据
                this.moreList();
			},
			//获取站点
			getTree(){
				var that = this;
				this.$axios.get(__Config.api.gettree,{
					params: {
						siteId:0
					}
				})
				.then(function (res) {
				       //拿到 所有的省
				    	that.treeList= res.data.data[0].children;
					})
				.catch(function (err) {
					console.log(err);
					});
				},
			//点击一级省
				//点击一级
			clickItem(data,id,code,index){
				this.twoData= data;
				this.siteId = id;
				this.siteCode =code;
				this.current2=index;
				//再次拉去数据
                this.moreList(); 
				
			},
			//点击diqu
			clickItem1(id,code,index){
				this.siteId = id;
				this.siteCode =code;
				this.current3=index;
				//再次拉去数据
                this.moreList(); 
			},
			//打开详情
			opendetail(id){
            //    localStorage.setItem("Zhaokaoid",id);
			// 	this.$router.push({  
			// 		name:"ZhaokaoMoreDetail" , 
			// 	}) 

				this.$router.push({  
						path: '/ZhaokaoMoreDetail', 
						name:"ZhaokaoMoreDetail" , 
						    query: {   
							id: id,   
						}   
					}) 
			},
		},
		created(){
		    this.getTree();
			this.getType();
		}
	}
</script>

<style scoped>
/**加载更多**/ 

	.more{
		width: 100%;
		height: 30px;
	
		margin: 0 auto;
	}
	.more p{
		text-align: center;
		line-height: 30px;
		font-size: 14px;
		color: #666;
	}
	.blue{
	background: rgba(0, 124, 207, 1);
	color: #fff;
	}
	.blue1{
	background: rgba(0, 124, 207, 1);
	color: #fff;
	}
	.blue2{
	background: rgba(0, 124, 207, 1);
	color: #fff;
	}
	.ZhaokaoMore {
		width: 95%;
		margin: 0 auto;
	    height: 100%;
	}
	.serchbtn{
	  display: flex;
	  margin-top: 5px;
	}
	.serchbtn p:nth-child(1){
		flex: 1;
	}
	.serchbtn p:nth-child(2){
		width: 50px;
    height: 23px;
    background: #1989fa80;
    text-align: center;
    line-height: 26px;
    font-size: 13px;
    color: #fff;
}




	/**/

	.listSwiper {
		width: 95%;
		margin: 20px auto;
	}

	/* */
	.listSwiper ul li {
		width: 99%;
		height: 80px;
		background: #fff;
		margin-top: 8px;
		box-shadow: 0px 2px 5px rgba(0, 124, 216, 0.16);
		border-radius: 7px;
		display: flex;
	}

	.listSwiper ul li .listL {
		width: 80px;
		height: 100%;

	}

	.listL .icontype1 {
		width: 55px;
		height: 55px;
		border: 1px solid rgba(0, 124, 207, 1);
		border-radius: 5px;
		margin: 10px 10px;
	}

	.listL .icontype1 p {
		font-size: 20px;
		font-family: Microsoft YaHei;
		font-weight: bold;
		line-height: 26px;
		color: rgba(0, 124, 207, 1);
		text-align: center;
	}

	.icontype2 {
		width: 55px;
		height: 55px;
		border: 1px solid #FFBB00;
		border-radius: 5px;
		margin: 10px 10px;
	}

	.listL .icontype2 p {
		font-size: 20px;
		font-family: Microsoft YaHei;
		font-weight: bold;
		line-height: 26px;
		color: #FFBB00;
		text-align: center;
	}

	.icontype3 {
		width: 55px;
		height: 55px;
		border: 1px solid #7D00CF;
		border-radius: 5px;
		margin: 10px 10px;
	}

	.listL .icontype3 p {
		font-size: 20px;
		font-family: Microsoft YaHei;
		font-weight: bold;
		line-height: 26px;
		color: #7D00CF;
		text-align: center;
	}



	.listSwiper ul li .listR {
		flex: 1;
		height: 100%;
		margin-left: 20px;
		margin-right: 13px;
	}

	.listR p:nth-child(1) {
		height: 18px;
		overflow: hidden;
		margin-top: 2px;
		width: 98%;
	}

	.listR p:nth-child(1) span:nth-child(1) {
		color: #007CCF;
		font-size: 12px;
		font-weight: 600;
		margin-left: -6px;
	}

	.listR p:nth-child(1) span:nth-child(2) {
		color: #333;
		font-size: 12px;
		font-weight: 600;
	}

	.listR p:nth-child(2) {
		height: 34px;
		overflow: hidden;
		font-size: 10px;
		font-weight: 300;
		margin-top: 5px;
		width: 98%;
		color: #666;
	}

	.listR p:nth-child(3) {
		height: 15px;
		overflow: hidden;
		font-size: 10px;
		font-weight: 300;
		margin-top: 2px;

	}

	.listR p:nth-child(3) span:nth-child(1) {
		font-size: 10px;
		font-weight: 600;
		line-height: 14px;
		color: rgba(0, 124, 207, 1);
	}

	.listR p:nth-child(3) span:nth-child(2) {
		float: right;
		margin-right: 10px;
		color: #666666;
	}
</style>



// WEBPACK FOOTER //
// src/components/ZhaokaoMore.vue